var body = document.body;
var header = document.getElementById('header');
window.addEventListener('scroll', function() {
	scrollpos = window.scrollY;
	if(scrollpos > 150){
		body.classList.add("scrolled");
		header.classList.add("header--bg");
	}
	else {	
		body.classList.remove("scrolled");	
		header.classList.remove("header--bg");
	}
});